module.exports = __webpack_public_path__ + "static/media/Calibre-Semibold.8325d174.ttf";